export const GAME_STATE_VERSION = 10
export const OID_PREFIX = 'OID_'
export const DATE_PREFIX = 'DATE_'
